import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/hooks/auth";
import AuthenticatedLayout from "@/layouts/AuthenticatedLayout";
import UnauthenticatedLayout from "@/layouts/UnauthenticatedLayout";
import Account from "@/pages/Account";
import ChangePassword from "@/pages/ChangePassword";
import Chat from "@/pages/Chat";
import ChatDetails from "@/pages/ChatDetails";
import Home from "@/pages/Home";
import Landing from "@/pages/Landing";
import NewConversation from "@/pages/NewConversation";
import NotFound from "@/pages/NotFound";
import Profile from "@/pages/Profile";
import RecoverPassword from "@/pages/RecoverPassword";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { PostHogProvider } from "posthog-js/react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // staleTime: 5 * 60 * 1000, // 5 minutes
      // gcTime: 10 * 60 * 1000, // 10 minutes
    },
  },
});

const phOptions = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: "2025-05-24" as const,
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<UnauthenticatedLayout />}>
        <Route path="/" element={<Landing />} />
        <Route path="recover-password" element={<RecoverPassword />} />
      </Route>
      <Route element={<AuthenticatedLayout />}>
        <Route path="home" element={<Home />} />
        <Route path="chat/:characterId" element={<Chat />} />
        <Route path="chat/:characterId/details" element={<ChatDetails />} />
        <Route path="account" element={<Account />} />
        <Route path="profile" element={<Profile />} />
        <Route path="new-conversation" element={<NewConversation />} />
        <Route path="change-password" element={<ChangePassword />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

// A very cool app
const App = () => (
  <PostHogProvider apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY} options={phOptions}>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <TooltipProvider>
          <Toaster />
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </TooltipProvider>
      </AuthProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </PostHogProvider>
);

export default App;
